import React, { useState } from 'react';
import { FiTag, FiPercent } from 'react-icons/fi';
import PortalHeader from '../../components/Portal/PortalHeader';
import ProductCard from '../../components/Portal/ProductCard';
import ProductDetailModal from '../../components/Portal/ProductDetailModal';
import LoginModal from '../../components/Portal/LoginModal';
import { useProductsOnSale } from '../../hooks/portal/usePortal';
import { useAuth } from '../../contexts/AuthContext';
import './Ofertas.scss';

const Ofertas = () => {
  const { products, loading } = useProductsOnSale(50); // Get up to 50 products on sale
  const { isAuthenticated } = useAuth();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showLoginModal, setShowLoginModal] = useState(false);

  const handleProductClick = (product) => {
    setSelectedProduct(product);
  };

  const handleCloseModal = () => {
    setSelectedProduct(null);
  };

  const handleLoginRequired = () => {
    setShowLoginModal(true);
  };

  // Calculate stats for offers
  const getOfferStats = () => {
    if (!products || products.length === 0) return null;

    const avgDiscount = products.reduce((sum, product) => {
      const regularPrice = parseFloat(product.sale_price || 0);
      const salePrice = parseFloat(product.sale_discount_price || 0);
      if (regularPrice > 0 && salePrice > 0) {
        const discount = ((regularPrice - salePrice) / regularPrice) * 100;
        return sum + discount;
      }
      return sum;
    }, 0) / products.length;

    return {
      totalOffers: products.length,
      avgDiscount: avgDiscount.toFixed(0)
    };
  };

  const stats = getOfferStats();

  if (loading) {
    return (
      <div className="portal-page">
        <PortalHeader />
        <div className="portal-page__loading">Cargando ofertas...</div>
      </div>
    );
  }

  return (
    <div className="portal-page ofertas">
      <PortalHeader />

      <div className="portal-page__container">
        <div className="ofertas__header">
          <div className="header-content">
            <h1 className="portal-page__title">
              <FiTag /> Ofertas Especiales
            </h1>
            <p className="subtitle">
              ¡Aprovecha nuestros mejores descuentos!
            </p>
          </div>

          {stats && (
            <div className="offer-stats">
              <div className="stat-card">
                <div className="stat-icon">
                  <FiTag />
                </div>
                <div className="stat-info">
                  <span className="stat-value">{stats.totalOffers}</span>
                  <span className="stat-label">Productos en oferta</span>
                </div>
              </div>
              <div className="stat-card discount">
                <div className="stat-icon">
                  <FiPercent />
                </div>
                <div className="stat-info">
                  <span className="stat-value">{stats.avgDiscount}%</span>
                  <span className="stat-label">Descuento promedio</span>
                </div>
              </div>
            </div>
          )}
        </div>

        {products && products.length > 0 ? (
          <div className="productos-grid">
            {products.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                onClick={() => handleProductClick(product)}
                onLoginRequired={handleLoginRequired}
              />
            ))}
          </div>
        ) : (
          <div className="empty-state">
            <div className="empty-state__icon">
              <FiTag />
            </div>
            <h2>No hay ofertas disponibles</h2>
            <p>Revisa más tarde para ver nuevas promociones</p>
          </div>
        )}
      </div>

      {selectedProduct && (
        <ProductDetailModal
          product={selectedProduct}
          onClose={handleCloseModal}
          onLoginRequired={handleLoginRequired}
        />
      )}

      <LoginModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
      />
    </div>
  );
};

export default Ofertas;
